/* eslint-disable */
/* prettier-ignore */

import { emptyApi as api } from "./emptyApi";
export const addTagTypes = [
  "billing",
  "cases",
  "3rd-party",
  "funnel",
  "organisations",
  "users",
  "templates",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getLedgerHistoryV1: build.query<
        GetLedgerHistoryV1ApiResponse,
        GetLedgerHistoryV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/billing/ledger-history`,
          params: {
            year: queryArg.year,
          },
        }),
        providesTags: ["billing"],
      }),
      getProductsV1: build.query<GetProductsV1ApiResponse, GetProductsV1ApiArg>(
        {
          query: () => ({ url: `/api/v1/billing/products` }),
          providesTags: ["billing"],
        },
      ),
      createCheckoutSessionV1: build.mutation<
        CreateCheckoutSessionV1ApiResponse,
        CreateCheckoutSessionV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/billing/checkout-session`,
          method: "POST",
          body: queryArg.checkoutSessionRequest,
        }),
        invalidatesTags: ["billing"],
      }),
      createAutoTopUpV1: build.mutation<
        CreateAutoTopUpV1ApiResponse,
        CreateAutoTopUpV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/billing/topup`,
          method: "POST",
          body: queryArg.createAutoTopUpRequest,
        }),
        invalidatesTags: ["billing"],
      }),
      updateAutoTopUpV1: build.mutation<
        UpdateAutoTopUpV1ApiResponse,
        UpdateAutoTopUpV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/billing/topup`,
          method: "PUT",
          body: queryArg.updateAutoTopUpRequest,
        }),
        invalidatesTags: ["billing"],
      }),
      getCasesApiV1CasesGet: build.query<
        GetCasesApiV1CasesGetApiResponse,
        GetCasesApiV1CasesGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases`,
          params: {
            page: queryArg.page,
            per_page: queryArg.perPage,
            query: queryArg.query,
            sorting: queryArg.sorting,
            status: queryArg.status,
          },
        }),
        providesTags: ["cases"],
      }),
      createCaseApiV1CasesPost: build.mutation<
        CreateCaseApiV1CasesPostApiResponse,
        CreateCaseApiV1CasesPostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases`,
          method: "POST",
          body: queryArg.caseCreatePublicRequest,
        }),
        invalidatesTags: ["cases", "3rd-party"],
      }),
      deleteCaseApiV1CasesCaseIdDelete: build.mutation<
        DeleteCaseApiV1CasesCaseIdDeleteApiResponse,
        DeleteCaseApiV1CasesCaseIdDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["cases"],
      }),
      getCaseApiV1CasesCaseIdGet: build.query<
        GetCaseApiV1CasesCaseIdGetApiResponse,
        GetCaseApiV1CasesCaseIdGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/v1/cases/${queryArg.caseId}` }),
        providesTags: ["cases"],
      }),
      updateCaseApiV1CasesCaseIdUpdatePut: build.mutation<
        UpdateCaseApiV1CasesCaseIdUpdatePutApiResponse,
        UpdateCaseApiV1CasesCaseIdUpdatePutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}`,
          method: "PUT",
          body: queryArg.updateCasePublicRequest,
        }),
        invalidatesTags: ["cases", "3rd-party"],
      }),
      downloadCaseApiV1CasesCaseIdUploadedGet: build.query<
        DownloadCaseApiV1CasesCaseIdUploadedGetApiResponse,
        DownloadCaseApiV1CasesCaseIdUploadedGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/download`,
        }),
        providesTags: ["cases"],
      }),
      markCaseAsDownloadedApiV1CasesPut: build.mutation<
        MarkCaseAsDownloadedApiV1CasesPutApiResponse,
        MarkCaseAsDownloadedApiV1CasesPutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/downloaded`,
          method: "PUT",
        }),
        invalidatesTags: ["cases"],
      }),
      retryUploadCaseApiV1Put: build.mutation<
        RetryUploadCaseApiV1PutApiResponse,
        RetryUploadCaseApiV1PutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/upload`,
          method: "PUT",
        }),
        invalidatesTags: ["cases"],
      }),
      markCaseAsRejectedApiV1Put: build.mutation<
        MarkCaseAsRejectedApiV1PutApiResponse,
        MarkCaseAsRejectedApiV1PutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/reject`,
          method: "PUT",
          body: queryArg.markAsRejectedRequest,
        }),
        invalidatesTags: ["cases"],
      }),
      retryBasingApiV1Put: build.mutation<
        RetryBasingApiV1PutApiResponse,
        RetryBasingApiV1PutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/retry/basing`,
          method: "PUT",
          body: queryArg.retryBasingRequest,
        }),
        invalidatesTags: ["cases"],
      }),
      sentToFunnelApiV1CasesCaseIdSendPut: build.mutation<
        SentToFunnelApiV1CasesCaseIdSendPutApiResponse,
        SentToFunnelApiV1CasesCaseIdSendPutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/send/funnel`,
          method: "PUT",
        }),
        invalidatesTags: ["cases", "funnel"],
      }),
      markCaseUploadedApiV1CasesCaseIdUploadedPut: build.mutation<
        MarkCaseUploadedApiV1CasesCaseIdUploadedPutApiResponse,
        MarkCaseUploadedApiV1CasesCaseIdUploadedPutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/mark-uploaded`,
          method: "PUT",
        }),
        invalidatesTags: ["cases", "3rd-party"],
      }),
      createOrganisationApiV1OrganisationsPost: build.mutation<
        CreateOrganisationApiV1OrganisationsPostApiResponse,
        CreateOrganisationApiV1OrganisationsPostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/organisations`,
          method: "POST",
          body: queryArg.organisationCreateRequestDto,
        }),
        invalidatesTags: ["organisations"],
      }),
      getOrganisationApiV1OrganisationsOrgIdGet: build.query<
        GetOrganisationApiV1OrganisationsOrgIdGetApiResponse,
        GetOrganisationApiV1OrganisationsOrgIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/organisations/${queryArg.orgId}`,
        }),
        providesTags: ["organisations"],
      }),
      getOrganisationSubscriptionApiV1OrganisationsOrgIdGet: build.query<
        GetOrganisationSubscriptionApiV1OrganisationsOrgIdGetApiResponse,
        GetOrganisationSubscriptionApiV1OrganisationsOrgIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/organisations/${queryArg.orgId}/billing`,
        }),
        providesTags: ["organisations"],
      }),
      getSignedBeaconIdentityV1Get: build.query<
        GetSignedBeaconIdentityV1GetApiResponse,
        GetSignedBeaconIdentityV1GetApiArg
      >({
        query: () => ({ url: `/api/v1/signed/beacon/identity` }),
        providesTags: ["users", "organisations"],
      }),
      getTemplatesApiV1TemplatesGet: build.query<
        GetTemplatesApiV1TemplatesGetApiResponse,
        GetTemplatesApiV1TemplatesGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/templates`,
          params: {
            pagination: queryArg.pagination,
            page: queryArg.page,
            per_page: queryArg.perPage,
            query: queryArg.query,
            sorting: queryArg.sorting,
          },
        }),
        providesTags: ["templates"],
      }),
      createTemplateApiV1TemplatesPost: build.mutation<
        CreateTemplateApiV1TemplatesPostApiResponse,
        CreateTemplateApiV1TemplatesPostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/templates`,
          method: "POST",
          body: queryArg.templateCreatePublic,
        }),
        invalidatesTags: ["templates"],
      }),
      deleteTemplateApiV1TemplatesTemplateIdDelete: build.mutation<
        DeleteTemplateApiV1TemplatesTemplateIdDeleteApiResponse,
        DeleteTemplateApiV1TemplatesTemplateIdDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/templates/${queryArg.templateId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["templates"],
      }),
      getTemplateApiV1TemplatesTemplateIdGet: build.query<
        GetTemplateApiV1TemplatesTemplateIdGetApiResponse,
        GetTemplateApiV1TemplatesTemplateIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/templates/${queryArg.templateId}`,
        }),
        providesTags: ["templates"],
      }),
      updateTemplateApiV1TemplatesTemplateIdPut: build.mutation<
        UpdateTemplateApiV1TemplatesTemplateIdPutApiResponse,
        UpdateTemplateApiV1TemplatesTemplateIdPutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/templates/${queryArg.templateId}`,
          method: "PUT",
          body: queryArg.templateUpdatePublic,
        }),
        invalidatesTags: ["templates"],
      }),
      createUsersApiV1UsersPost: build.mutation<
        CreateUsersApiV1UsersPostApiResponse,
        CreateUsersApiV1UsersPostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/users`,
          method: "POST",
          body: queryArg.createUserRequest,
        }),
        invalidatesTags: ["users"],
      }),
      updateUserApiV1UsersUserIdAcceptTermsPatch: build.mutation<
        UpdateUserApiV1UsersUserIdAcceptTermsPatchApiResponse,
        UpdateUserApiV1UsersUserIdAcceptTermsPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/users/${queryArg.userId}/accept-terms`,
          method: "PATCH",
        }),
        invalidatesTags: ["users"],
      }),
      resetUserApiV1UsersUserIdResetPut: build.mutation<
        ResetUserApiV1UsersUserIdResetPutApiResponse,
        ResetUserApiV1UsersUserIdResetPutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/users/${queryArg.userId}/reset`,
          method: "PUT",
        }),
        invalidatesTags: ["users"],
      }),
      verifyEmailApiV1UsersUserIdVerifyEmailPost: build.mutation<
        VerifyEmailApiV1UsersUserIdVerifyEmailPostApiResponse,
        VerifyEmailApiV1UsersUserIdVerifyEmailPostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/users/${queryArg.userId}/verify-email`,
          method: "POST",
        }),
        invalidatesTags: ["users"],
      }),
      getRolesApiV1UsersRolesGet: build.query<
        GetRolesApiV1UsersRolesGetApiResponse,
        GetRolesApiV1UsersRolesGetApiArg
      >({
        query: () => ({ url: `/api/v1/users/roles` }),
        providesTags: ["users"],
      }),
      searchUsersApiV1UsersSearchGet: build.query<
        SearchUsersApiV1UsersSearchGetApiResponse,
        SearchUsersApiV1UsersSearchGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/users/search`,
          params: {
            page: queryArg.page,
            per_page: queryArg.perPage,
            query: queryArg.query,
            sorting: queryArg.sorting,
          },
        }),
        providesTags: ["users"],
      }),
      deleteUserApiV1UsersUserIdDelete: build.mutation<
        DeleteUserApiV1UsersUserIdDeleteApiResponse,
        DeleteUserApiV1UsersUserIdDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/users/${queryArg.userId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["users"],
      }),
      searchUserApiV1UsersUserIdGet: build.query<
        SearchUserApiV1UsersUserIdGetApiResponse,
        SearchUserApiV1UsersUserIdGetApiArg
      >({
        query: (queryArg) => ({ url: `/api/v1/users/${queryArg.userId}` }),
        providesTags: ["users"],
      }),
      updateUserApiV1UsersUserIdPatch: build.mutation<
        UpdateUserApiV1UsersUserIdPatchApiResponse,
        UpdateUserApiV1UsersUserIdPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/users/${queryArg.userId}`,
          method: "PATCH",
          body: queryArg.updateUserRequest,
        }),
        invalidatesTags: ["users"],
      }),
      changeUserRoleApiV1Patch: build.mutation<
        ChangeUserRoleApiV1PatchApiResponse,
        ChangeUserRoleApiV1PatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/users/${queryArg.userId}/roles/${queryArg.role}`,
          method: "PATCH",
        }),
        invalidatesTags: ["users"],
      }),
      authenticateFunnelApiV1FunnelPost: build.mutation<
        AuthenticateFunnelApiV1FunnelPostApiResponse,
        AuthenticateFunnelApiV1FunnelPostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/integrations/funnel/authenticate`,
          method: "POST",
          body: queryArg.authenticateFunnelRequest,
        }),
        invalidatesTags: ["funnel"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as baseClientApi };
export type GetLedgerHistoryV1ApiResponse =
  /** status 200 Successful Response */ PaginatedLedgerHistory;
export type GetLedgerHistoryV1ApiArg = {
  /** The year ledger history should be downloaded for. */
  year: number;
};
export type GetProductsV1ApiResponse =
  /** status 200 Successful Response */ GetProductsResponse;
export type GetProductsV1ApiArg = void;
export type CreateCheckoutSessionV1ApiResponse =
  /** status 200 Successful Response */ CheckoutSessionResponse;
export type CreateCheckoutSessionV1ApiArg = {
  checkoutSessionRequest: CheckoutSessionRequest;
};
export type CreateAutoTopUpV1ApiResponse =
  /** status 200 Successful Response */ CheckoutSessionResponse;
export type CreateAutoTopUpV1ApiArg = {
  createAutoTopUpRequest: CreateAutoTopUpRequest;
};
export type UpdateAutoTopUpV1ApiResponse = unknown;
export type UpdateAutoTopUpV1ApiArg = {
  updateAutoTopUpRequest: UpdateAutoTopUpRequest;
};
export type GetCasesApiV1CasesGetApiResponse =
  /** status 200 Successful Response */ PaginatedCaseReadPublic;
export type GetCasesApiV1CasesGetApiArg = {
  /** The page number. */
  page?: number | null;
  /** The number of items per page. */
  perPage?: number | null;
  /** This parameter expects a Lucene query string for filtering results. For more information on the syntax, please refer to the [Lucene Query Parser documentation](https://lucene.apache.org/core/2_9_4/queryparsersyntax.html). Note: fuzzy and proximity searches, boosting terms and field grouping are not supported. Wildcard matches using * is supported.You can filter by the following fields: org_id. */
  query?: string | null;
  /** This parameter expects a sort query string for sorting results.  This should be a comma-separated list of {field_name}:{direction} pairs. The direction can be either '-1' or '1' for descending and ascending respectively. For example, 'name:1,created_at:-1'. You can sort by the following fields: id, name. */
  sorting?: string | null;
  /** Provides the ability to filter cases by status. */
  status?: string | null;
};
export type CreateCaseApiV1CasesPostApiResponse =
  /** status 200 Successful Response */ CaseCreatePublicResponse;
export type CreateCaseApiV1CasesPostApiArg = {
  caseCreatePublicRequest: CaseCreatePublicRequest;
};
export type DeleteCaseApiV1CasesCaseIdDeleteApiResponse = unknown;
export type DeleteCaseApiV1CasesCaseIdDeleteApiArg = {
  /** Case ID */
  caseId: number;
};
export type GetCaseApiV1CasesCaseIdGetApiResponse =
  /** status 200 Successful Response */ CaseReadPublic;
export type GetCaseApiV1CasesCaseIdGetApiArg = {
  /** Case ID */
  caseId: number;
};
export type UpdateCaseApiV1CasesCaseIdUpdatePutApiResponse =
  /** status 200 Successful Response */ CaseReadPublic;
export type UpdateCaseApiV1CasesCaseIdUpdatePutApiArg = {
  /** Case ID */
  caseId: number;
  updateCasePublicRequest: {
    /** New name for the case */
    name?: string | null;
  };
};
export type DownloadCaseApiV1CasesCaseIdUploadedGetApiResponse =
  /** status 200 Successful Response */ CaseDownload;
export type DownloadCaseApiV1CasesCaseIdUploadedGetApiArg = {
  /** Case ID */
  caseId: number;
};
export type MarkCaseAsDownloadedApiV1CasesPutApiResponse =
  /** status 200 Successful Response */ CaseReadPublic;
export type MarkCaseAsDownloadedApiV1CasesPutApiArg = {
  /** Case ID */
  caseId: number;
};
export type RetryUploadCaseApiV1PutApiResponse =
  /** status 200 Successful Response */ CaseRetryUpload;
export type RetryUploadCaseApiV1PutApiArg = {
  /** The ID of the Case to retry uploading */
  caseId: number;
};
export type MarkCaseAsRejectedApiV1PutApiResponse = unknown;
export type MarkCaseAsRejectedApiV1PutApiArg = {
  /** The ID of the Case to reject */
  caseId: number;
  markAsRejectedRequest: {
    /** A reason why the case was rejected */
    rejected_for?: string | null;
  };
};
export type RetryBasingApiV1PutApiResponse = unknown;
export type RetryBasingApiV1PutApiArg = {
  /** The ID of the Case to retry */
  caseId: number;
  retryBasingRequest: RetryBasingRequest;
};
export type SentToFunnelApiV1CasesCaseIdSendPutApiResponse = unknown;
export type SentToFunnelApiV1CasesCaseIdSendPutApiArg = {
  /** Case ID */
  caseId: number;
};
export type MarkCaseUploadedApiV1CasesCaseIdUploadedPutApiResponse =
  /** status 200 Successful Response */ CaseReadPublic;
export type MarkCaseUploadedApiV1CasesCaseIdUploadedPutApiArg = {
  /** Case ID */
  caseId: number;
};
export type CreateOrganisationApiV1OrganisationsPostApiResponse =
  /** status 201 Successful Response */ OrganisationReadDto;
export type CreateOrganisationApiV1OrganisationsPostApiArg = {
  organisationCreateRequestDto: OrganisationCreateRequestDto;
};
export type GetOrganisationApiV1OrganisationsOrgIdGetApiResponse =
  /** status 200 Successful Response */ OrganisationReadDto;
export type GetOrganisationApiV1OrganisationsOrgIdGetApiArg = {
  /** The ID of the organisation to get */
  orgId: number;
};
export type GetOrganisationSubscriptionApiV1OrganisationsOrgIdGetApiResponse =
  /** status 200 Successful Response */ OrganisationSubscription;
export type GetOrganisationSubscriptionApiV1OrganisationsOrgIdGetApiArg = {
  /** The ID of the organisation to get */
  orgId: number;
};
export type GetSignedBeaconIdentityV1GetApiResponse =
  /** status 200 Successful Response */ SignedBeaconIdentity;
export type GetSignedBeaconIdentityV1GetApiArg = void;
export type GetTemplatesApiV1TemplatesGetApiResponse =
  /** status 200 Successful Response */ PaginatedTemplateReadPublic;
export type GetTemplatesApiV1TemplatesGetApiArg = {
  /** Pagination is enabled when true or not provided. */
  pagination?: boolean | null;
  /** The page number. */
  page?: number | null;
  /** The number of items per page. */
  perPage?: number | null;
  /** This parameter expects a Lucene query string for filtering results. For more information on the syntax, please refer to the [Lucene Query Parser documentation](https://lucene.apache.org/core/2_9_4/queryparsersyntax.html). Note: fuzzy and proximity searches, boosting terms and field grouping are not supported. Wildcard matches using * is supported.You can filter by the following fields: org_id. */
  query?: string | null;
  /** This parameter expects a sort query string for sorting results.  This should be a comma-separated list of {field_name}:{direction} pairs. The direction can be either '-1' or '1' for descending and ascending respectively. For example, 'name:1,created_at:-1'. You can sort by the following fields: created_at, deleted_at, name, id. */
  sorting?: string | null;
};
export type CreateTemplateApiV1TemplatesPostApiResponse =
  /** status 200 Successful Response */ TemplateReadPublic;
export type CreateTemplateApiV1TemplatesPostApiArg = {
  templateCreatePublic: TemplateCreatePublic;
};
export type DeleteTemplateApiV1TemplatesTemplateIdDeleteApiResponse = unknown;
export type DeleteTemplateApiV1TemplatesTemplateIdDeleteApiArg = {
  /** The ID of the template to update */
  templateId: number;
};
export type GetTemplateApiV1TemplatesTemplateIdGetApiResponse =
  /** status 200 Successful Response */ TemplateReadPublic;
export type GetTemplateApiV1TemplatesTemplateIdGetApiArg = {
  /** The ID of the template to get */
  templateId: number;
};
export type UpdateTemplateApiV1TemplatesTemplateIdPutApiResponse = unknown;
export type UpdateTemplateApiV1TemplatesTemplateIdPutApiArg = {
  /** The ID of the template to update */
  templateId: number;
  templateUpdatePublic: TemplateUpdatePublic;
};
export type CreateUsersApiV1UsersPostApiResponse =
  /** status 201 Successful Response */ CreateUserResponse;
export type CreateUsersApiV1UsersPostApiArg = {
  createUserRequest: CreateUserRequest;
};
export type UpdateUserApiV1UsersUserIdAcceptTermsPatchApiResponse = unknown;
export type UpdateUserApiV1UsersUserIdAcceptTermsPatchApiArg = {
  /** The id of the user */
  userId: string;
};
export type ResetUserApiV1UsersUserIdResetPutApiResponse = unknown;
export type ResetUserApiV1UsersUserIdResetPutApiArg = {
  /** The ID of the user */
  userId: string;
};
export type VerifyEmailApiV1UsersUserIdVerifyEmailPostApiResponse = unknown;
export type VerifyEmailApiV1UsersUserIdVerifyEmailPostApiArg = {
  /** The id of the user */
  userId: string;
};
export type GetRolesApiV1UsersRolesGetApiResponse =
  /** status 200 Successful Response */ RolesResponse;
export type GetRolesApiV1UsersRolesGetApiArg = void;
export type SearchUsersApiV1UsersSearchGetApiResponse =
  /** status 200 Successful Response */ UsersPaginatedListRead;
export type SearchUsersApiV1UsersSearchGetApiArg = {
  /** The page number. */
  page?: number | null;
  /** The number of items per page. */
  perPage?: number | null;
  /** This parameter expects a Lucene query string for filtering results. For more information on the syntax, please refer to the [Lucene Query Parser documentation](https://lucene.apache.org/core/2_9_4/queryparsersyntax.html). Note: fuzzy and proximity searches, boosting terms and field grouping are not supported. Wildcard matches using * is supported.You can filter by the following fields: name, email. */
  query?: string | null;
  /** This parameter expects a sort query string for sorting results.  This should be a comma-separated list of {field_name}:{direction} pairs. The direction can be either '-1' or '1' for descending and ascending respectively. For example, 'name:1,created_at:-1'. You can sort by the following fields: name, email. */
  sorting?: string | null;
};
export type DeleteUserApiV1UsersUserIdDeleteApiResponse = unknown;
export type DeleteUserApiV1UsersUserIdDeleteApiArg = {
  /** The ID of the user */
  userId: string;
};
export type SearchUserApiV1UsersUserIdGetApiResponse =
  /** status 200 Successful Response */ UserReadDto;
export type SearchUserApiV1UsersUserIdGetApiArg = {
  /** The ID of the user */
  userId: string;
};
export type UpdateUserApiV1UsersUserIdPatchApiResponse = unknown;
export type UpdateUserApiV1UsersUserIdPatchApiArg = {
  /** The ID of the user */
  userId: string;
  updateUserRequest: UpdateUserRequest;
};
export type ChangeUserRoleApiV1PatchApiResponse = unknown;
export type ChangeUserRoleApiV1PatchApiArg = {
  /** The ID of the user */
  userId: string;
  /** The role the user should be assigned */
  role: string;
};
export type AuthenticateFunnelApiV1FunnelPostApiResponse = unknown;
export type AuthenticateFunnelApiV1FunnelPostApiArg = {
  authenticateFunnelRequest: AuthenticateFunnelRequest;
};
export type CaseStatus =
  | "pending_upload"
  | "uploaded"
  | "files_converted"
  | "preprocessed"
  | "failed"
  | "done"
  | "downloaded"
  | "rejected"
  | "unpaid_upload";
export type CaseContent = "upper" | "lower" | "combined";
export type ParametersForModelBase = {
  /** Specifies if the model base is hollow */
  hollow?: boolean;
  /** Specifies if the model should have a full palate */
  full_palate?: boolean;
};
export type ModelTextStyle = "embossed" | "engraved";
export type ParametersForModelText = {
  text_style?: ModelTextStyle | null;
};
export type ModelAttachmentTypes = "pillars";
export type ParametersForModelAttachments = {
  attachment_type?: ModelAttachmentTypes | null;
};
export type CaseOptions = {
  base_params?: ParametersForModelBase | null;
  text_params?: ParametersForModelText | null;
  attachment_params?: ParametersForModelAttachments | null;
};
export type LambdaStep =
  | "model_basing_lambda_step_proto2files"
  | "model_basing_lambda_step_preprocessing"
  | "model_basing_lambda_step_basing";
export type AlgorithmStep =
  | "model_basing_algorithm_step_none"
  | "model_basing_algorithm_step_preprocessing"
  | "model_basing_algorithm_step_tooth_segmentation"
  | "model_basing_algorithm_step_occlusal_plane_generation"
  | "model_basing_algorithm_step_border_cropping"
  | "model_basing_algorithm_step_model_hollowing"
  | "model_basing_algorithm_step_pillar_generation"
  | "model_basing_algorithm_step_vent_generation"
  | "model_basing_algorithm_step_text_generation"
  | "model_basing_algorithm_step_prepare_for_print";
export type EventStatus = "passed" | "failed" | "warning" | "skipped";
export type ErrorKey =
  | "model_basing_preprocessing_error"
  | "model_basing_tooth_segmentation_error"
  | "model_basing_occlusal_plane_error"
  | "model_basing_hollowing_error"
  | "model_basing_pillar_generation_error"
  | "model_basing_vent_generation_error"
  | "model_basing_text_generation_error"
  | "model_basing_text_generation_warning"
  | "model_basing_basing_error"
  | "timeout_error";
export type ReadEventLog = {
  logged_at: string;
  lambda_step: LambdaStep;
  algorithm_step: AlgorithmStep;
  status: EventStatus;
  error_key?: ErrorKey;
};
export type CaseReadPublic = {
  id: number;
  org_id: number;
  name: string;
  status: CaseStatus;
  created_at: string;
  created_by: string;
  completed_at?: string | null;
  rejected_by?: string;
  content: CaseContent;
  case_options: CaseOptions;
  logs?: ReadEventLog[];
  upper_scan_thumbnail_presigned_url?: string;
  lower_scan_thumbnail_presigned_url?: string;
  combined_scan_thumbnail_presigned_url?: string;
  upper_model_thumbnail_presigned_url?: string;
  lower_model_thumbnail_presigned_url?: string;
  combined_model_thumbnail_presigned_url?: string;
};
export type AppMetadata = {
  organisation?: number;
};
export type RoleModel = {
  id: string;
  name: string;
  privilege: number;
};
export type UserReadDto = {
  user_id?: string | null;
  app_metadata?: AppMetadata | null;
  email?: string | null;
  email_verified?: boolean | null;
  name?: string | null;
  picture?: string | null;
  blocked?: boolean | null;
  /** User roles and permissions */
  roles?: RoleModel[];
};
export type LedgerHistoryEntry = {
  case: CaseReadPublic | null;
  user: UserReadDto | null;
  created_at: string;
  kind: "grant" | "hold" | "debit" | "release" | "refund";
  amount: number;
  description: string;
};
export type PaginatedLedgerHistory = {
  page?: number | null;
  page_size?: number | null;
  count?: number | null;
  total_count?: number | null;
  content?: LedgerHistoryEntry[];
};
export type Error = {
  /** Error Translation Key */
  error_key?: string | null;
  /** English Error Message */
  default_message?: string | null;
  /** Additional information */
  details?: string | null;
};
export type GetProductsResponse = {
  products: {
    id: string;
    num_credits: number;
    price_usd: number;
  }[];
  credit_cost_per_case: number;
};
export type CheckoutSessionResponse = {
  url: string;
};
export type CheckoutSessionRequest = {
  purchases: object;
};
export type CreateAutoTopUpRequest = {
  product_price_id: string;
  product_quantity: number;
  credit_threshold: number;
};
export type UpdateAutoTopUpRequest = {
  product_price_id: string | null;
  product_quantity: number | null;
  credit_threshold: number | null;
};
export type PaginatedCaseReadPublic = {
  page?: number | null;
  page_size?: number | null;
  count?: number | null;
  total_count?: number | null;
  content?: CaseReadPublic[];
};
export type CaseCreatePublicResponse = {
  id: number;
  org_id: number;
  status: CaseStatus;
  created_at: string;
  created_by: string;
  presigned_url: string | null;
  content: CaseContent;
};
export type CaseCreatePublicRequestWithCaseOptions = {
  name: string;
  case_content?: CaseContent;
  case_options: CaseOptions;
};
export type CaseCreatePublicRequestWithTemplate = {
  name: string;
  case_content?: CaseContent;
  template_id: number;
};
export type CaseCreatePublicRequest =
  | CaseCreatePublicRequestWithCaseOptions
  | CaseCreatePublicRequestWithTemplate;
export type CaseDownload = {
  upper_scan_presigned_url?: string;
  lower_scan_presigned_url?: string;
  upper_model_presigned_url?: string;
  lower_model_presigned_url?: string;
  upper_scan_thumbnail_presigned_url?: string;
  lower_scan_thumbnail_presigned_url?: string;
  combined_scan_thumbnail_presigned_url?: string;
  upper_model_thumbnail_presigned_url?: string;
  lower_model_thumbnail_presigned_url?: string;
  combined_model_thumbnail_presigned_url?: string;
};
export type CaseRetryUpload = {
  presigned_url: string;
};
export type RetryBasingRequest = {
  case_options: CaseOptions;
};
export type OrganisationReadDto = {
  id: number;
  name: string;
  created_at: string;
  balance: {
    available: number;
    held: number;
  };
  auto_top_up?: {
    status: "pending" | "active" | "processing" | "failed" | "cancelled";
    product_price_id: string;
    product_quantity: number;
    credit_threshold: number;
  };
};
export type OrganisationCreateRequestDto = {
  name: string;
  affiliate_code?: string;
};
export type OrganisationSubscription = {
  type?: string | null;
  end?: string | null;
  payment_issue: boolean;
  trial_ending: boolean;
};
export type SignedBeaconIdentity = {
  user_name: string;
  user_id: string;
  user_email?: string;
  role_name: string | null;
  org_name: string;
  org_id: string;
  signed_hash: string;
};
export type TemplateReadPublic = {
  id: number;
  org_id: number | null;
  name: string;
  case_options: CaseOptions;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
};
export type PaginatedTemplateReadPublic = {
  page?: number | null;
  page_size?: number | null;
  count?: number | null;
  total_count?: number | null;
  content?: TemplateReadPublic[];
};
export type TemplateCreatePublic = {
  name?: string | null;
  case_options?: CaseOptions | null;
};
export type TemplateUpdatePublic = {
  name?: string;
  case_options?: CaseOptions | null;
};
export type CreateUserResponse = {
  user_id: string;
};
export type CreateUserRequest = {
  email: string;
  roles: string[];
};
export type RolesResponse = {
  roles: RoleModel[];
};
export type UsersPaginatedListRead = {
  page?: number | null;
  page_size?: number | null;
  count?: number | null;
  total_count?: number | null;
  content?: UserReadDto[];
};
export type UpdateUserRequest = {
  name?: string | null;
  picture?: string | null;
};
export type AuthenticateFunnelRequest = {
  code?: string;
};
export const {
  useGetLedgerHistoryV1Query,
  useGetProductsV1Query,
  useCreateCheckoutSessionV1Mutation,
  useCreateAutoTopUpV1Mutation,
  useUpdateAutoTopUpV1Mutation,
  useGetCasesApiV1CasesGetQuery,
  useCreateCaseApiV1CasesPostMutation,
  useDeleteCaseApiV1CasesCaseIdDeleteMutation,
  useGetCaseApiV1CasesCaseIdGetQuery,
  useUpdateCaseApiV1CasesCaseIdUpdatePutMutation,
  useDownloadCaseApiV1CasesCaseIdUploadedGetQuery,
  useMarkCaseAsDownloadedApiV1CasesPutMutation,
  useRetryUploadCaseApiV1PutMutation,
  useMarkCaseAsRejectedApiV1PutMutation,
  useRetryBasingApiV1PutMutation,
  useSentToFunnelApiV1CasesCaseIdSendPutMutation,
  useMarkCaseUploadedApiV1CasesCaseIdUploadedPutMutation,
  useCreateOrganisationApiV1OrganisationsPostMutation,
  useGetOrganisationApiV1OrganisationsOrgIdGetQuery,
  useGetOrganisationSubscriptionApiV1OrganisationsOrgIdGetQuery,
  useGetSignedBeaconIdentityV1GetQuery,
  useGetTemplatesApiV1TemplatesGetQuery,
  useCreateTemplateApiV1TemplatesPostMutation,
  useDeleteTemplateApiV1TemplatesTemplateIdDeleteMutation,
  useGetTemplateApiV1TemplatesTemplateIdGetQuery,
  useUpdateTemplateApiV1TemplatesTemplateIdPutMutation,
  useCreateUsersApiV1UsersPostMutation,
  useUpdateUserApiV1UsersUserIdAcceptTermsPatchMutation,
  useResetUserApiV1UsersUserIdResetPutMutation,
  useVerifyEmailApiV1UsersUserIdVerifyEmailPostMutation,
  useGetRolesApiV1UsersRolesGetQuery,
  useSearchUsersApiV1UsersSearchGetQuery,
  useDeleteUserApiV1UsersUserIdDeleteMutation,
  useSearchUserApiV1UsersUserIdGetQuery,
  useUpdateUserApiV1UsersUserIdPatchMutation,
  useChangeUserRoleApiV1PatchMutation,
  useAuthenticateFunnelApiV1FunnelPostMutation,
} = injectedRtkApi;
